module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "size": "sm",
      "title": "Delete Suggestion",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('div', {
    staticClass: "flex justify-center mt-10 mb-4"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-exclamation text-4xl text-red-500"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text-center px-20 text-gray-800 mb-8"
  }, [_vm._v("\n    Are you sure you want to delete this\n    "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("' " + _vm._s(_vm.suggestion.text) + " '")]), _vm._v(" ? This\n    "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("action is irreversible")]), _vm._v(" and has\n    consequences "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("only in this course.")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmMessage),
      expression: "confirmMessage"
    }],
    ref: "confirmDeleteSuggestion",
    staticClass: "bg-gray-100 rounded py-3 px-4 outline-none mx-12 mb-2",
    attrs: {
      "placeholder": "Please type 'confirm' to continue"
    },
    domProps: {
      "value": (_vm.confirmMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mx-12 mb-16",
    class: _vm.errorMessage !== 'No Error' ? 'text-red-500' : 'text-white'
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center bottom-10"
  }, [_c('button', {
    staticClass: "bg-gray-100 rounded px-5 py-2 mr-3",
    on: {
      "click": function($event) {
        return _vm.$emit('openMySuggestionsModal')
      }
    }
  }, [_vm._v("\n      Cancel\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "px-5 py-2 bg-red-500 rounded text-white",
    on: {
      "click": function($event) {
        return _vm.deleteSuggestion()
      }
    }
  }, [_vm._v("\n      Delete Suggestion\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-e103e866!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/Participants/DeleteSuggestionSaved.vue
// module id = 1818
// module chunks = 61